import React from 'react'

/**
 * Creates a scroll handler function that calculates which card is closest to the center
 * of the scroll container and calls the provided callback with the active index.
 *
 * @param scrollContainerRef - Reference to the scrollable container element
 * @param cardRefs - Array of references to the card elements
 * @param setActiveIndex - Callback function to update the active index
 * @returns A scroll handler function
 */
export const createScrollHandler =
  (
    scrollContainerRef: React.RefObject<HTMLDivElement>,
    cardRefs: React.MutableRefObject<Array<HTMLDivElement | null>>,
    setActiveIndex: (index: number) => void
  ): (() => void) =>
  () => {
    if (!scrollContainerRef.current) return

    const scrollLeft = scrollContainerRef.current.scrollLeft
    const containerWidth = scrollContainerRef.current.clientWidth
    const scrollCenter = scrollLeft + containerWidth / 2

    let closestIndex = 0
    let minDistance = Infinity

    cardRefs.current.forEach((ref, index) => {
      if (!ref) return
      const cardLeft = ref.offsetLeft
      const cardWidth = ref.offsetWidth
      const cardCenter = cardLeft + cardWidth / 2
      const distance = Math.abs(cardCenter - scrollCenter)

      if (distance < minDistance) {
        minDistance = distance
        closestIndex = index
      }
    })

    setActiveIndex(closestIndex)
  }
